import React from 'react';
import { withRouter } from 'react-router-dom';

import classes from './AuthButton.css';

const button = props => (
    <button className={[classes.Button, classes[props.btnType]].join(' ')}
    onClick={props.clicked} disabled={props.disabled}>
        {props.children}
    </button>
)

export default withRouter(button);


// WEBPACK FOOTER //
// ./src/components/UI/Buttons/AuthButton/AuthButton.js